"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./TextStatic.scss");
exports.TextStatic = function (props) {
    var staticTextElement = (React.createElement("p", { className: 'form-control-static' }, props.TextValue));
    if (!props.LabelText) {
        return (staticTextElement);
    }
    return (React.createElement("div", { className: 'form-group' },
        React.createElement("label", { className: 'control-label', style: { color: props.LabelColor || '#686868' } }, props.LabelText),
        React.createElement("span", { style: { color: props.ValueColor || '#1F1F1F' } }, staticTextElement)));
};
//# sourceMappingURL=TextStatic.js.map